export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14444.90428aee.jpg";